var _line, _line2, _line3, _line4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCapacity(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "ionicon",
    viewBox: "0 0 300 300",
    strokeWidth: 20,
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 150,
    x2: 150,
    y1: 0,
    y2: 120
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: 120,
    y2: 120,
    x1: 50,
    x2: 250
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: 180,
    y2: 180,
    x1: 50,
    x2: 250
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 150,
    x2: 150,
    y1: 180,
    y2: 300
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapacity);
export default __webpack_public_path__ + "static/media/capacity.de396a9254c399d91ae5712d888b5da9.svg";
export { ForwardRef as ReactComponent };